import { PaperClipIcon } from "@heroicons/react/24/outline"
import {
  MagnifyingGlassIcon,
  ChevronDownIcon,
  EyeIcon
} from "@heroicons/react/24/outline";
import React from "react"
import { useTranslation } from "../../contexts/LanguageContext";

const transactions = [
    {
        id: 1,
        sellerUsername: "Waseem",
        type: "Subscription",
        referenceId: "MSD-23223",
        date:"03/80/2023",
        amount: 283.23,
        currency: "USD",
        attachment: "#"
    }

  ]
  
  export default function AllTransactions() {
    const { t } = useTranslation();
    return (
      <div className="bg-white rounded-[10px] border border-dashboardStroke shadow-[0px_9px_15px_rgba(0,0,0,0.07)] overflow-hidden">
        {/* Dark Header */}
        <div className="bg-dashboardDark h-16 px-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h2 className="text-white font-semibold text-lg">{t("transactions.title")}</h2>
            <span className="text-white font-semibold">({transactions.length})</span>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 px-3 py-1.5 border border-white rounded">
              <MagnifyingGlassIcon className="w-[18px] h-[18px] text-white" />
              <input
                type="text"
                placeholder={t("common.search")}
                className="bg-transparent text-white placeholder-white/70 text-sm font-light outline-none w-28"
              />
            </div>

            <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
              <span>{t("common.sortBy")}</span>
              <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
            </button>

            <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
              <span>{t("common.dateRange")}</span>
              <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-dashboardStroke">
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("col.srNo")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("transactions.col.seller")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("col.type")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("transactions.col.referenceId")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("col.amount")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("transactions.col.date")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-semibold text-dashboardText">{t("transactions.col.attachment")}</th>
                <th className="px-4 py-4 text-left text-[17px] font-medium text-dashboardText">{t("col.actions")}</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction, index) => (
                <tr 
                  key={transaction.id}
                  className={`border-b border-dashboardStroke hover:bg-gray-50 transition-colors ${
                    index === 0 ? "shadow-[inset_3px_0px_0px_#FF7C17]" : ""
                  }`}
                >
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {transaction.id}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-medium text-dashboardCoral">
                    {transaction.sellerUsername}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {(() => {
                      // Map known type values onto translation keys; otherwise show the raw value.
                      const slug = (transaction.type || "").toLowerCase().replace(/\s+/g, "");
                      const key = `transactions.type.${slug}`;
                      const translated = t(key);
                      return translated !== key ? translated : transaction.type;
                    })()}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {transaction.referenceId}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {transaction.amount + ' ' + transaction.currency}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap text-base font-normal text-dashboardDarkText">
                    {transaction.date}
                  </td>
                  <td className="px-4 py-4 whitespace-nowrap">
                    <PaperClipIcon className="w-6 text-dashboardCoral" />
                  </td>
                  <td className="px-4 py-4">
                    <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                      <EyeIcon className="w-6 h-6 text-dashboardDark" strokeWidth={1.3} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
  